import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Box from "@material-ui/core/Box";
import MuiAvatar from "@material-ui/core/Avatar";
import PersonIcon from "@material-ui/icons/Person";

const StyledAvatar = styled(MuiAvatar)`
  border: solid 1px #fff;
  background-color: ${({ $hasImage, theme }) =>
    $hasImage ? "#f2f2f2" : theme.color.primary.dark};
  width: ${props => props.size}px;
  height: ${props => props.size}px;

  svg {
    color: #fff;
    font-size: ${props => props.size * 0.55}px;
  }
`;

const AvatarInfo = styled.div`
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  align-self: center;
  justify-content: space-around;
  height: ${props => props.size}px;
  * {
    margin-bottom: 0;
  }
`;

const Container = ({ alt, src, size, gutterBottom, children }) => {
  const [imageSrc, setImageSrc] = useState(src);

  useEffect(() => {
    setImageSrc(src);
  }, [src]);

  const hasImage = Boolean(imageSrc);

  return (
    <Box display="flex" size={size} mb={gutterBottom ? 2 : 0}>
      <StyledAvatar
        alt={alt}
        src={hasImage ? imageSrc : undefined}
        size={size}
        $hasImage={hasImage}
        imgProps={{
          onError: () => setImageSrc(undefined)
        }}
      >
        {!hasImage && <PersonIcon />}
      </StyledAvatar>
      {children && <AvatarInfo size={size}>{children}</AvatarInfo>}
    </Box>
  );
};

Container.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  ...MuiAvatar.propTypes,
  ...{
    size: PropTypes.number
  }
};

Container.defaultProps = {
  size: 34
};

export default Container;
